import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Play = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M30.447 15.106a.998.998 0 010 1.789l-28 14a1.005 1.005 0 01-.973-.044A1.001 1.001 0 011 30V2a1 1 0 011.447-.894zM3 28.382L27.764 16 3 3.618z" })), '0 0 32 32', 'Play');
//# sourceMappingURL=Play.js.map